import { SocialMedia } from '../SocialMedia';
import { Copyright } from '../Copyright';
import { ServiceList } from './service-list/ServiceList';
import { ErrorBoundary } from 'react-error-boundary';

export function CompanyInfo() {
  return (
    <div className="tlw-flex tlw-flex-col tlw-justify-between md:tlw-gap-8">
      <ErrorBoundary fallback={<div>ServiceList</div>}>
        <ServiceList />
      </ErrorBoundary>

      <ErrorBoundary fallback={<div>SocialMedia</div>}>
        <SocialMedia className="tlw-mt-12 tlw-mb-5 md:tlw-hidden" />
      </ErrorBoundary>

      <ErrorBoundary fallback={<div>Copyright</div>}>
        <Copyright />
      </ErrorBoundary>
    </div>
  );
}
